// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalOverlay_PD075 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--_00000020-background);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  transition: opacity 300ms ease-in-out;
}

.modalContent_vP6hQ {
  background-color: var(--f5-background);
  border-radius: 8px;
  /* box-shadow: 0 2px 10px var(--_00000020-shadow); */
  width: 742px;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transform: scale(1);
  padding-bottom: 18px;
  animation: scaleUp_sQmPK_OZS3x 300ms ease-out forwards;
  border-radius: 8px;
  overflow: hidden;
}

.scaleDown_pabTo {
  animation: scaleDown_pabTo 300ms ease-in forwards;
}

@keyframes scaleUp_sQmPK {
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
}

@keyframes scaleDown_pabTo {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(0);
  }
}

.fadeOut_vYO1L {
  opacity: 0;
}

.upgradePlanHeader_ffnez {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 64px;
  border-bottom: 1px solid var(--e3-border);
}

.headerLeft_DVZ8Z {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--_2-color);
  font-size: 20px;
  font-weight: 600;
  gap: 10px;
}

.closeIcon_gRuwH {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  cursor: pointer;
  border-radius: 4px;
  background: var(--f6-background);
  -webkit-user-select: none;
          user-select: none;
}

.checkCircle_yX2KG {
  align-self: center;
  width: 87px;
  height: 87px;
  border-radius: 50%;
  background-color: #eeeeef;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 13px;
}

.upgradePlanText_zMklU {
  color: var(--595959-color);
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
}

.upgradePlanContent_AFLcR {
  display: flex;
  gap: 20px;
  padding: 20px;
  width: 85%;
  margin: 0 auto;
  flex-direction: column;
  background-color: var(--white-color);
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  border: 1px solid var(--ececf1-border);
}



.acceptButton_K_uLy {
  height: 44px;
  width: 109px;
  border-radius: 8px;
  background: #233f39;
  display: flex;
  align-items: center;
  color: var(--white-background);
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid #233f39;
  outline: none;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/PlanUpdatedModal/PlanUpdatedModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,oDAAoD;EACpD,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,sDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iDAA2C;AAC7C;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,UAAU;EACV,cAAc;EACd,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,sCAAsC;AACxC;;;;AAIA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--_00000020-background);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999999;\n  transition: opacity 300ms ease-in-out;\n}\n\n.modalContent {\n  background-color: var(--f5-background);\n  border-radius: 8px;\n  /* box-shadow: 0 2px 10px var(--_00000020-shadow); */\n  width: 742px;\n  max-width: 600px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  transform: scale(1);\n  padding-bottom: 18px;\n  animation: scaleUp_sQmPK 300ms ease-out forwards;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: scale(0);\n  }\n\n  to {\n    transform: scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: scale(1);\n  }\n\n  to {\n    transform: scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n\n.upgradePlanHeader {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  height: 64px;\n  border-bottom: 1px solid var(--e3-border);\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: var(--_2-color);\n  font-size: 20px;\n  font-weight: 600;\n  gap: 10px;\n}\n\n.closeIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  cursor: pointer;\n  border-radius: 4px;\n  background: var(--f6-background);\n  user-select: none;\n}\n\n.checkCircle {\n  align-self: center;\n  width: 87px;\n  height: 87px;\n  border-radius: 50%;\n  background-color: #eeeeef;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 13px;\n}\n\n.upgradePlanText {\n  color: var(--595959-color);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.upgradePlanContent {\n  display: flex;\n  gap: 20px;\n  padding: 20px;\n  width: 85%;\n  margin: 0 auto;\n  flex-direction: column;\n  background-color: var(--white-color);\n  border-radius: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border: 1px solid var(--ececf1-border);\n}\n\n\n\n.acceptButton {\n  height: 44px;\n  width: 109px;\n  border-radius: 8px;\n  background: #233f39;\n  display: flex;\n  align-items: center;\n  color: var(--white-background);\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 500;\n  border: 1px solid #233f39;\n  outline: none;\n  cursor: pointer;\n  user-select: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `modalOverlay_PD075`,
	"modalContent": `modalContent_vP6hQ`,
	"scaleUp_sQmPK": `scaleUp_sQmPK_OZS3x`,
	"scaleDown": `scaleDown_pabTo`,
	"fadeOut": `fadeOut_vYO1L`,
	"upgradePlanHeader": `upgradePlanHeader_ffnez`,
	"headerLeft": `headerLeft_DVZ8Z`,
	"closeIcon": `closeIcon_gRuwH`,
	"checkCircle": `checkCircle_yX2KG`,
	"upgradePlanText": `upgradePlanText_zMklU`,
	"upgradePlanContent": `upgradePlanContent_AFLcR`,
	"acceptButton": `acceptButton_K_uLy`,
	"scaleUp": `scaleUp_sQmPK`
};
export default ___CSS_LOADER_EXPORT___;
